type GetAuthHeaders = () => Promise<Headers>;

let _getAuthHeaders: GetAuthHeaders | null = null;
let _baseUrl = import.meta.env.VITE_FRONTERA_REST_ENDPOINT || "";

let _resolveReady: (() => void) | null = null;
const _readyPromise = new Promise<void>((resolve) => {
  _resolveReady = resolve;
});

/**
 * Registers the function used to obtain auth headers for private REST requests.
 * Resolves the ready promise so any in-flight customFetch calls stop waiting.
 */
export const setRestAuthGetter = (fn: GetAuthHeaders) => {
  _getAuthHeaders = fn;
  _resolveReady?.();
};

/**
 * Sets the base URL for all REST requests.
 * Called once at app startup, keeping import.meta.env out of custom-fetcher.ts
 * so Orval's esbuild step doesn't warn about it.
 */
export const setRestBaseUrl = (url: string) => {
  _baseUrl = url;
};

/**
 * Returns the current base URL for REST requests.
 */
export const getRestBaseUrl = () => _baseUrl;

/**
 * Waits until setRestAuthGetter has been called, then returns auth headers.
 * Prevents the race condition where child component effects fire before
 * AppShell's effect has registered the auth getter.
 */
export const getRestAuthHeaders = async (): Promise<Headers> => {
  await _readyPromise;
  return _getAuthHeaders!();
};
